import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from './theme/ThemeContext'
import { DirectionProvider } from './theme/DirectionProvider'
import { ToastProvider } from './components/ToastProvider'
import App from './App'
import SettingsHydrator from './components/SettingsHydrator'
import './i18n'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30000, // 30 seconds
    },
  },
})

// Router basename is derived from Vite's `base` (import.meta.env.BASE_URL).
// In production the app is served under /AdminConsole/ (shared apps portal),
// so all routes resolve relative to that prefix; in dev BASE_URL is '/'.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <SettingsHydrator />
        <DirectionProvider>
          <ToastProvider>
            <BrowserRouter basename={import.meta.env.BASE_URL}>
              <App />
            </BrowserRouter>
          </ToastProvider>
        </DirectionProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
